import { render, staticRenderFns } from "./Anatomy.vue?vue&type=template&id=71add46e&"
import script from "./Anatomy.vue?vue&type=script&lang=js&"
export * from "./Anatomy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports